// extracted by mini-css-extract-plugin
export default {"modal-backdrop":"Dialog_modal-backdrop__MSiPh","logout-dialog-container":"Dialog_logout-dialog-container__ICtGK","modal-view":"Dialog_modal-view__in1TA"};